import React from 'react'
import './Hero.css'

function Hero() {
    return (
        <div className="hero-container">
            <img className='image0' src='/images/Rama.png' alt='himalayas'/>
            <div className="heading">
               <h1 className='welcome'>Welcome</h1>
               <h1 className='avalokana'>to Avalokana</h1>
               <h3>"Liberation through Truth"</h3>
               <div className="sub-wrapper">
               <h3 className="typing-demo">History | Philosophy | Culture</h3>
               </div>
            </div>
        </div>
    )
}

export default Hero
